const contactData = [
  {
    id: 1,
    title: "Email",
    link: "nuralam13003@gmail.com",
    href: "mailto:nuralam13003@gmail.com",
  },
  {
    id: 3,
    title: "WhatsApp",
    link: "+880 1558921846",
    href: "https://wa.me/8801558921846",
  },
  {
    id: 4,
    title: "LinkedIn",
    link: "Nur Alam",
    href: "https://www.linkedin.com/in/nur-alam-noyon-2835681b8/",
  },
];

export default contactData;
